var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitening(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whitening") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whitening"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5,34a1,1,0,0,1-2,0A7.5,7.5,0,0,0,42,26.5a1,1,0,0,1,0-2,7.52,7.52,0,0,0,5.31-2.19,7.71,7.71,0,0,0,1.1-1.41,12.52,12.52,0,0,0-12.09-2.22,13.19,13.19,0,0,1-8.64,0,12.5,12.5,0,0,0-5.21-.63A12.67,12.67,0,0,0,11.05,29.46a12.53,12.53,0,0,0,2.82,9.13,17.86,17.86,0,0,1,3.56,7.75c.68,3.33,1.53,7.47,2.12,10.31a4.2,4.2,0,0,0,8.19.15l1.81-7.41a2.52,2.52,0,0,1,4.9,0l1.81,7.41a4.2,4.2,0,0,0,8.19-.15c.59-2.84,1.44-7,2.12-10.31a17.86,17.86,0,0,1,3.56-7.75,12.54,12.54,0,0,0,2.83-9A7.43,7.43,0,0,0,51.5,34ZM32,25.72a20.58,20.58,0,0,1-9.76-2.67,1,1,0,0,1,1-1.7A19,19,0,0,0,32,23.72a19,19,0,0,0,8.72-2.37,1,1,0,1,1,1,1.7A20.58,20.58,0,0,1,32,25.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,32a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H6A1,1,0,0,0,7,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,31H58a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V6A1,1,0,0,0,32,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,44.13l-2.59,1.5a1,1,0,0,0,1,1.74L10,45.87a1,1,0,0,0-1-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.52,20a1,1,0,0,0,.5-.13l2.59-1.5a1,1,0,1,0-1-1.74L54,18.13a1,1,0,0,0,.5,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.13,10a1,1,0,1,0,1.74-1l-1.5-2.59a1,1,0,1,0-1.74,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,10.35A1,1,0,0,0,45.87,10l1.5-2.59a1,1,0,0,0-1.74-1L44.13,9A1,1,0,0,0,44.5,10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,18.13l-2.59-1.5a1,1,0,0,0-1,1.74L9,19.87a1,1,0,0,0,1-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.61,45.63,55,44.13a1,1,0,0,0-1,1.74l2.59,1.5a1,1,0,0,0,.5.13,1,1,0,0,0,.5-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,32a6.53,6.53,0,0,1,1.9-4.6l.15-.13h0A6.49,6.49,0,0,1,57,25.5,6.49,6.49,0,0,1,50.5,19a6.5,6.5,0,0,1-.8,3.13,6.64,6.64,0,0,1-1.1,1.47A6.53,6.53,0,0,1,44,25.5,6.5,6.5,0,0,1,50.5,32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitening);
export default __webpack_public_path__ + "static/media/whitening.9287d83d5b1711d430e145f712939209.svg";
export { ForwardRef as ReactComponent };